export default "__VITE_ASSET__d5c1d3fd__"